import { render, staticRenderFns } from "./modal-social-report-content.vue?vue&type=template&id=9cc06aa6&scoped=true&lang=pug"
import script from "./modal-social-report-content.js?vue&type=script&lang=js&external"
export * from "./modal-social-report-content.js?vue&type=script&lang=js&external"
import style0 from "./modal-social-report-content.vue?vue&type=style&index=0&id=9cc06aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc06aa6",
  null
  
)

export default component.exports